import clsx from "clsx";
import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";

export type ColSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type ColGap = "none" | "xs" | "sm" | "md" | "lg" | "xl" | "2xl";

export interface ColProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: ColGap;
  xs?: ColSize;
  sm?: ColSize;
  md?: ColSize;
  lg?: ColSize;
}

function generateSize(size: ColSize) {
  return size === 12 ? "w-full" : `w-${size}/12`;
}

const Col = forwardRef<HTMLDivElement, ColProps>((props, ref) => {
  const {
    className,
    gap = "none",
    xs,
    sm = xs,
    md = sm,
    lg = md,
    ...rest
  } = props;

  return (
    <div
      {...rest}
      ref={ref}
      className={twMerge(
        clsx("flex flex-col", {
          "gap-1": gap === "xs",
          "gap-2": gap === "sm",
          "gap-3": gap === "md",
          "gap-4": gap === "lg",
          "gap-6": gap === "xl",
          "gap-8": gap === "2xl",
        }),
        !!xs ? generateSize(xs) : undefined,
        !!sm && sm !== xs ? `sm:${generateSize(sm)}` : undefined,
        !!md && md !== sm ? `md:${generateSize(md)}` : undefined,
        !!lg && lg !== md ? `lg:${generateSize(lg)}` : undefined,
        className
      )}
    />
  );
});

export default Col;
